import React from "react";

export default function FormIcon() {
  return (
    <svg width={17} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#56368A"
        d="m10.136 4 2.193.415L14.136 4l-4-4-.552 1.896L10.136 4Z"
      />
      <path
        fill="#7248B9"
        d="M10.136 4V0H3.591A1.09 1.09 0 0 0 2.5 1.09v13.82c0 .602.488 1.09 1.09 1.09h9.455a1.09 1.09 0 0 0 1.091-1.09V4h-4Z"
      />
      <path
        fill="#fff"
        d="M5.59 11.544a.546.546 0 1 1 .001-1.091.546.546 0 0 1 0 1.091Zm0-2.181a.546.546 0 1 1 .001-1.092.546.546 0 0 1 0 1.092Zm0-2.182a.546.546 0 1 1 .001-1.092.546.546 0 0 1 0 1.092Zm6 4.272H7.045v-.909h4.545v.91Zm0-2.181H7.045v-.91h4.545v.91Zm0-2.182H7.045v-.91h4.545v.91Z"
      />
    </svg>
  );
}
